import React, { useEffect } from "react";

import useSelect from "~components/Form/hooks/useSelect";

import prepareForOptions from "~services/utils/prepareForOptions";
import useCidades from "~/fetchs/useCidades";

const useCidadeForm = (formikRef, estadoSigla) => {
  const cidadeSelect = useSelect("cidade");

  const { cidades, loading, searchCidadeById } = useCidades({ formikRef, estadoSigla });

  const defaultOption = prepareForOptions(
    [{ nome: "Selecione o estado para buscar as cidades", id: null }],
    "nome",
    "id"
  );
  const cidadesOptions = estadoSigla ? prepareForOptions(cidades, "nome", "id") : defaultOption;

  const fillCidadeById = (id) => {
    searchCidadeById(id).then((data) => {
      if (data) {
        const cidade = prepareForOptions([data], "nome", "id")[0];

        handleChangeCidade(cidade);
      }
    });
  };

  const handleChangeCidade = (cidade) => {
    if (!cidade) return;

    cidadeSelect.upDateValue(cidade.value);
    cidadeSelect.upDateDefaultValue(cidade.value ? cidade : "");

    formikRef?.current?.setFieldValue("cidadeId", cidade.value, false);
    formikRef?.current?.setFieldTouched("cidadeId", true, false);

    formikRef?.current?.setFieldValue("cidadeLabel", cidade.label, false)
  };

  return {
    loadingCidade: loading,
    cidades: cidadesOptions,
    cidadeSelect,
    handleChangeCidade,
    fillCidadeById,
  };
};

export default useCidadeForm;
